<template>
    <div :id="rootElementId" :style="`height:${heightComputed}px`" class="d-flex justify-center"></div>
</template>

<script>
import { getDataUrl } from "../../utils/functions";
export default {
  name: "GameAvatarMedia",
  computed: {
    rootElementId() {
      return `gameAvatarMedia${this.id}`;
    },
    darkMode(){
      return this.$vuetify.theme.dark;
    },
    heightComputed(){
      return this.height > 50 ? this.height : 50;
    }
  },
  props:{
    game:{
      type: Object,
      required: true
    },
    id:{
      required: true
    },
    height:{
      type:Number,
      default:100
    },
    width:{
      type: Number,
      default: 300
    },
    leftColor:{
      type: String,
      default: "#3366FF"
    },
    rightColor:{
      type: String,
      default: "#3366FF"
    },
    bgColor:{
      type: String,
      default: "white"
    },
    margin:{
      type: Object,
      required: false
    },
    titleLeft:{
      type: String,
      default: ""
    },
    titleRight:{
      type: String,
      default: ""
    },
    subtitle:{
      type: String,
      default: ""
    },
    subtitle2:{
      type: String,
      default: ""
    },
    textColor:{
      type: String,
      default: "#000000"
    },
    type:{
      type:String,
      default:"radar"
    },
    lineDistance:{
      type:String,
      required: "32"
    },
    lineWeight:{
      type:String,
      required: "2"
    },
    avatarSize:{
      type:String,
      required: "48"
    },
    titleFontSize:{
      type: String,
      required: "18"
    },
    titleFontWeight:{
      type: String,
      default: "900"
    },
    subtitleFontSize:{
      type: String,
      required:"14"
    },
    subtitleFontWeight:{
      type: String,
      default: "400"
    },
    subtitle2FontSize:{
      type: String,
      required:"12"
    },
    subtitle2FontWeight:{
      type: String,
      default: "300"
    },
    embed:{
      type:Boolean,
      default: false
    }
  },
  watch: {
    "orientation": function(newVal, oldVal) {
      this.printD3(true);
    },
  },
  data() {
    return {
      images: {}
    };
  },
  mounted: function() {
    window.addEventListener("resize", this.onWindowResize);
    this.printD3();
  },
  created() {},
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    printD3(force = false){
      if(force){
        this.images = {}
      }
      const scale = d3.scale.linear()
      .range([0.86, 0.92])
      .domain([650, 1000]);
      let SVG_WIDTH
      if(this.type === "radar"){
        SVG_WIDTH = this.width * 0.85 > 350 ? this.width * scale(this.width) : 350;
      }else{
        SVG_WIDTH = this.width; 
      }

      if(this.embed){
        SVG_WIDTH = this.width;
      }

      d3.select(`#${this.rootElementId}`).select("svg").remove();

      var svg = d3.select(`#${this.rootElementId}`).append("svg")
      .attr("width", SVG_WIDTH)
      .attr("height", this.heightComputed)
      .style("fill", this.darkMode ? "cfcfcf" : "black")
      .style("background", this.bgColor)
      .attr("class", "gameAvatarMedia")
      .attr("id",`${this.rootElementId}SVG`)

      this.drawCenter(svg,SVG_WIDTH);
    },
    drawImageBase64(svg,x,y,width,height,img,className,idName,bottom = false,extraParams={}) {
      if(!this.images[idName]){
        let base_image = new Image();
        base_image.crossOrigin = "anonymous";
        base_image.src = img;
        base_image.onload = (event) => {
          const dataUrl = getDataUrl(event.currentTarget);
          this.drawImage(
          svg,
          x,
          y,
          width,
          height,
          dataUrl,
          className,
          idName,
          bottom,
          extraParams
          );
        }
      }else{
        if(bottom){
          svg.node().insertBefore(this.images[idName],svg.node().firstChild);
        }else{
          svg.node().appendChild(this.images[idName]);
        }
      }
    },
    drawImage: function(svg, x, y, width, height, img,className,idName,bottom = false,extraParams={}) {
      let imgNode = bottom ? svg.insert("svg:image",":first-child") : svg.append("svg:image");
        imgNode.attr("x", x - (width / 2))
        .attr("y",  y - (height / 2))
        .attr("width", width)
        .attr("height", height)
        .attr("xlink:href", img)
        .attr("class",className)
        _.forEach(extraParams,(value,key) => {
          imgNode.attr(key,value);
        })
      this.images[idName] = imgNode.node().cloneNode(true);
    },
    drawRectangle(svg, x, y, width, height, color, opacity, className) {
      svg.append("rect")
        .attr("class", className)
        .attr("x", x)
        .attr("y", y)
        .attr("width", width)
        .attr("height", height)
        .style("fill", color)
        .style("opacity", opacity);
    },
    drawLine(svg, x, y, distance,size, color, opacity, className) {
      svg.append('line')
        .attr("class", className)
        .style("stroke", color)
        .style("stroke-width", size)
        .attr("x1", x - (distance/2))
        .attr("y1", y)
        .attr("x2", x + (distance/2))
        .attr("y2", y)
        .style("opacity", opacity);
    },
    drawCircle(svg, x, y, radius, fillColor,borderColor,borderSize, opacity, className) {
      return svg.append("circle")
        .attr("class", className)
        .attr("r", radius)
        .attr("cx", x)
        .attr("cy", y)
        .style("fill", fillColor)
        .style("stroke", borderColor)
        .style("stroke-width", borderSize)
        .style("opacity", opacity);
    },
    drawText(svg,x,y,color,fontSize,fontWeight,text,anchor="middle"){
      return svg.append("text")
      .attr("x",x)
      .attr("y",y)
      .attr("fill", color)
      .attr("font-size", fontSize)
      .attr("font-family", "NeueMontreal")
      .attr("font-weight", fontWeight)
      .style("text-anchor",anchor)
      .text(text);
    },
    onWindowResize(){
      this.images = {};
      setTimeout(() => this.printD3(),100);
    },
    drawCenter(svg,SVG_WIDTH){
      //INI --- DRAW

      let upperTextSize = this.embed ? this.width * 0.025 : this.titleFontSize;
      if(upperTextSize > 22 && !this.titleFontSize){
        upperTextSize = 22;
      }
      let subtitleFontSize = this.embed ? this.width * 0.02 : this.subtitleFontSize;
      if(subtitleFontSize > 22 && !this.subtitleFontSize){
        subtitleFontSize = 22;
      }
      let subtitleFontSize2 = this.embed ? this.width * 0.018 : this.subtitleFontSize2;
      if(subtitleFontSize2 > 22 && !this.subtitleFontSize2){
        subtitleFontSize2 = 22;
      }
      
      //CENTRAL TEXT
      let centralTextX = SVG_WIDTH / 2;
      let centralTextY = this.heightComputed / 2;
      let centralText = `${this.game.homeTeamScore} - ${this.game.awayTeamScore}`;
      let centralTextObj = this.drawText(svg,centralTextX,centralTextY,this.textColor,this.titleFontSize,this.titleFontWeight,centralText);


      let lineDistance = (this.lineDistance && !this.embed) ? this.lineDistance : SVG_WIDTH*0.29;

      let subtitleY = centralTextY + (this.height * 0.2);
      this.drawText(svg,centralTextX,subtitleY,this.textColor,subtitleFontSize,this.subtitleFontWeight,this.subtitle);

      let subtitle2Y = centralTextY + (this.height * 0.4);
      this.drawText(svg,centralTextX,subtitle2Y,this.textColor,subtitleFontSize2,this.subtitle2FontWeight,this.subtitle2);

      let lineSize = this.lineWeight;
      let centralOffset = this.width * 0.02;
      let offsetYLine = this.height * 0.1;
      //LEFT AVATAR
      let leftLineX = centralTextX - (centralTextObj.node().getBoundingClientRect().width / 2) - (Number(lineDistance) / 2) - (centralOffset)
      let leftLineY = centralTextY - (this.titleFontSize / 3);
      this.drawLine(svg,leftLineX,leftLineY,lineDistance,lineSize,this.leftColor,1,"")
      let leftUrlImg = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.game.homeTeamId}.png`;
      let leftSizeImg = this.embed ? this.height * 0.5 : this.avatarSize * 0.7;
      let leftAvatarRadius = this.embed ? this.height * 0.33 : this.avatarSize / 2;
      let leftAvatarX = leftLineX - (lineDistance / 2) - leftAvatarRadius;
      let leftAvatarY = leftLineY;
      this.drawCircle(svg,leftAvatarX,leftAvatarY,leftAvatarRadius,"transparent",this.leftColor,lineSize,1,"")
      let leftClipPath = svg.append("clipPath").attr("id",`img-left-mask-circle-${this.rootElementId}`);
      this.drawCircle(leftClipPath,leftAvatarX,leftAvatarY,leftAvatarRadius,"transparent","",lineSize,1,"")
      this.drawImageBase64(svg,leftAvatarX,leftAvatarY,leftSizeImg,leftSizeImg,leftUrlImg,"leftAvatarImage","leftAvatarImage",true,{"clip-path":`url(#img-left-mask-circle-${this.rootElementId})`});
      this.drawText(svg,leftLineX,leftAvatarY - offsetYLine,this.textColor,upperTextSize,this.titleFontWeight,this.titleLeft);

      //RIGHT AVATAR
      let rightLineX = centralTextX + (centralTextObj.node().getBoundingClientRect().width / 2) + (Number(lineDistance) / 2) + (centralOffset)
      let rightLineY = centralTextY - (this.titleFontSize / 3);
      this.drawLine(svg,rightLineX,rightLineY,lineDistance,lineSize,this.rightColor,1,"")
      let rightUrlImg = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${this.game.awayTeamId}.png`;
      let rightSizeImg = this.embed ? this.height * 0.5 : this.avatarSize * 0.7;
      let rightAvatarRadius = this.embed ? this.height * 0.33 : this.avatarSize / 2;
      let rightAvatarX = rightLineX + (lineDistance / 2) + rightAvatarRadius;
      let rightAvatarY = rightLineY;
      this.drawCircle(svg,rightAvatarX,rightAvatarY,rightAvatarRadius,"transparent",this.rightColor,lineSize,1,"")
      let rightClipPath = svg.append("clipPath").attr("id",`img-right-mask-circle-${this.rootElementId}`);
      this.drawCircle(rightClipPath,rightAvatarX,rightAvatarY,rightAvatarRadius,"transparent","",lineSize,1,"")
      this.drawImageBase64(svg,rightAvatarX,rightAvatarY ,rightSizeImg,rightSizeImg,rightUrlImg,"rightAvatarImage","rightAvatarImage",true,{"clip-path":`url(#img-right-mask-circle-${this.rootElementId})`});
      this.drawText(svg,rightLineX,rightLineY - offsetYLine,this.textColor,upperTextSize,this.titleFontWeight,this.titleRight);

      //END --- DRAW
    },
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/game/GameAvatarMedia.vue